import { actions, endpoints } from '../../../utils/constants';
import { Get, Post } from '../../../utils/functions';
import { Notification } from '../../components/index';
import { put, takeEvery, call, all, select, takeLatest } from 'redux-saga/effects';

function* setCoaches(action) {
  const header = yield getHeader()
  try {
    const { status, data } = yield call(Get, endpoints.coaches, header);
    if (status === 200) {
      yield put({ type: actions.SET_COACHES_ARRAY, payload: data })
    }
    return status
  } catch (error) {
    yield Notification('error', 'Ops', 'Error ao atualizar os Coaches')
  }
}

function* setGlobal(action) {
  const header = yield getHeader()
  try {
    const { status, data } = yield call(Get, endpoints.global, header);
    if (status === 200) {
      yield put({ type: actions.SET_GLOBAL_STATUS, payload: data });
    }
    return status
  } catch (error) {
    yield Notification('error', 'Ops', 'Error ao atualizar Global')
  }
}

function* setLocal(action) {
  const header = yield getHeader()
  try {
    const { status, data } = yield call(Get, endpoints.local, header);
    if (status === 200) {
      yield put({ type: actions.SET_LOCAL_INFO, payload: data });
    }
    return status
  } catch (error) {
    yield Notification('error', 'Ops', 'Error ao atualizar Local')
  }
}

function* asyncInfo({ payload }) {
  yield put({ type: actions.SET_SYNC, payload: true })
  try {

    const responses = yield all([
      call(setLocal),
      call(setGlobal),
      call(setCoaches)
    ])
    const statusOk = responses.filter((status) => status === 200)
    if (payload && responses.length === statusOk.length) {
      yield Notification('success', ' Sucesso!', 'Todos os dados foram atualizados.')
    } else if (statusOk.length < responses.length) {
      yield Notification('info', 'Info', 'Alguns dados não foram carregados.')
    } else if (statusOk.length === 0) {
      yield Notification('error', 'Oops !', 'Não foi possivel atualizar.');
    }
    yield put({ type: actions.SET_SYNC, payload: false })
  } catch (error) {
    yield put({ type: actions.SET_SYNC, payload: false })
    yield Notification('error', 'Oops !', 'Não foi possivel atualizar.');
  }
}

function* getHeader() {
  const { token } = yield select(state => state.auth)
  return {
    'Authorization': `Bearer ${token}`
  }
}

export default function* StatisticsSaga() {
  yield all([
    yield takeEvery(actions.SET_ASYNC_COACHES, setCoaches),
    yield takeEvery(actions.SET_ASYNC_GLOBAL, setGlobal),
    yield takeLatest(actions.SET_ASYNC_LOCAL, setLocal),
    yield takeEvery(actions.SET_ASYNC_SYNC, asyncInfo)
  ]);
}


// WEBPACK FOOTER //
// ./src/App/containers/statistics/statistics.saga.js